import Card from "components/card";
import DonutChart from "components/charts/DonutChart";
import Loader from "components/loader";
import useStats from "hooks/useStats";
import { useEffect, useMemo } from "react";
import { DASHBOARD_COLORS } from "utils/dashboardColors";

const COLOR_CYCLE = [
  DASHBOARD_COLORS.base,
  DASHBOARD_COLORS.otros,
  DASHBOARD_COLORS.instituciones,
  DASHBOARD_COLORS.varios,
  DASHBOARD_COLORS.postulantes,
];

const SegmentacionActividadChart = () => {
  const { isLoading, response, fetchData } = useStats("segmentacion-actividad");

  useEffect(() => {
    fetchData(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const rows = useMemo(() => (Array.isArray(response) ? response : []), [response]);

  const chartOptions = useMemo(
    () => ({
      chart: { type: "donut" },
      labels: rows.map((item) => item.label || item.rango),
      colors: rows.map((_, idx) => COLOR_CYCLE[idx % COLOR_CYCLE.length]),
      legend: { show: true, position: "bottom" },
      dataLabels: { enabled: true },
      tooltip: { theme: "dark" },
    }),
    [rows]
  );

  const sinPostulaciones = useMemo(() => rows.find((item) => item.rango === "0"), [rows]);
  const totalUsuarios = useMemo(() => rows.reduce((acc, item) => acc + Number(item.count || 0), 0), [rows]);
  const porcentajeSinActivar = totalUsuarios > 0 && sinPostulaciones
    ? Math.round((Number(sinPostulaciones.count || 0) / totalUsuarios) * 1000) / 10
    : null;

  return (
    <Card extra="w-full h-[460px] px-6 py-4">
      <div className="text-xl font-bold text-navy-700 dark:text-white mb-2">
        Segmentación por nivel de actividad
      </div>

      <div className="mt-2 flex h-[300px] w-full items-center justify-center">
        {isLoading ? (
          <Loader />
        ) : rows.length === 0 ? (
          <p className="text-sm text-gray-600 dark:text-gray-400">No hay datos disponibles</p>
        ) : (
          <DonutChart options={chartOptions} series={rows.map((item) => Number(item.count || 0))} />
        )}
      </div>

      {porcentajeSinActivar !== null && (
        <p className="mt-2 text-xs text-gray-600 dark:text-gray-400">
          <span className="font-bold text-navy-700 dark:text-white">{porcentajeSinActivar}%</span> de los
          postulantes nunca se postuló ({sinPostulaciones.count} usuarios) — margen de activación.
        </p>
      )}
    </Card>
  );
};

export default SegmentacionActividadChart;
